import type { RowsPerPageOption } from '@ovComponents/2-component/dataTable';
import { usePageState } from '@utils/usePageState';
import { PAGE_SIZE } from './reconFlags.config';

export const useReconFlagsPagination = (): {
  page: number;
  setPage: (page: number) => void;
  pageSize: RowsPerPageOption;
  setPageSize: (size: RowsPerPageOption) => void;
} => {
  const [page, setPage] = usePageState(1, 'page');
  const [pageSize, setPageSize] = usePageState(PAGE_SIZE, 'pageSize');

  return {
    page,
    setPage,
    pageSize: pageSize as RowsPerPageOption,
    setPageSize: (size: RowsPerPageOption) => setPageSize(size),
  };
};
